import { render, staticRenderFns } from "./CardLabel.vue?vue&type=template&id=47b55850"
import script from "./CardLabel.vue?vue&type=script&setup=true&lang=js"
export * from "./CardLabel.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports